module.exports = __webpack_public_path__ + "img/6-1_07.d9a8368b.jpg";